import { connect, MapStateToProps } from 'react-redux';
import { PapiDaBrowseFaceted } from '@wix/da-types-papi';
import { getInitialOffset } from '../../selectors/stream';
import { Topic, RelatedTopics } from '@wix/da-shared-react/pkg/types/topics';
import { Props } from './TopicPage';
import { AppState } from '../../types/store';
import { getThisTopic, getRelatedTopics } from '../../selectors/page';

export type StateProps = Omit<Props, 'dropFirstTimeFlag'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const facet = state.facet as PapiDaBrowseFaceted;
  return {
    topic: getThisTopic(state) ?? ((facet.neco || {}) as Topic),
    relatedTopics:
      getRelatedTopics(state) ?? ((facet.topNecos || []) as RelatedTopics),
    estTotal: facet.estTotal,
    initialOffset: getInitialOffset(state),
  };
};

export default connect(mapStateToProps);
